import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getOrderItemDetails } from '../../../network/purchaseOrder';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getEncounterServicesAndItem } from '../../../network/Item';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApiIsStock } from '../../../network/appointment';
import { ModalAppItemDetailsSalesInvoice } from '../ModalApp/ModalApp';
import { BiSolidShow } from 'react-icons/bi';
import dayjs from 'dayjs';
const ItemListSalesInvoice = ({
  type,
  edit,
  setDataSourcePayment,
  setDataSourceTax,
  setDataSource,
  vatTax,
  priceList,
  isNationalitySaudi,
  dataSource,
  t,
  form,
}) => {
  // console.log('dataSourcedwdwqdwqdwqdqwsd', dataSource);

  const [count, setCount] = useState(0);
  const [searchTxt, setSearchTxt] = useState('');
  const [selectData, setSelectData] = useState({});
  const [open, setOpen] = useState(false);
  const [debouncedSearchTxt, setDebouncedSearchTxt] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { mutate: onGetItemDetails, data: itemDetails } = useMutation({
    mutationFn: (itemName) =>
      getOrderItemDetails('Sales Invoice', itemName, priceList),
    onSuccess: (itemDetails) => {
      console.log(itemDetails, 'itemDetails');
      const newDataSource = [...dataSource];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        ...itemDetails?.message,
        rate: itemDetails?.message?.price_list_rate,
        amount: itemDetails?.message?.price_list_rate,
        // item_code: itemDetails?.message?.description,
      };
      // setDataSourcePayment((prev) => [...prev,payment_amount]);
      setDataSource(newDataSource);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  useEffect(() => {
    if (itemDetails) {
      const currentItems = dataSource || [];
      const currentTaxes = form.getFieldValue('taxes') || [];
      console.log(isNationalitySaudi, 'isNationalitySaudi');

      const newItem = {
        item_code: itemDetails?.message?.item_code,
        rate: itemDetails?.message?.price_list_rate,
        qty: 1,
        discount_amount: 0,
        amount: itemDetails?.message?.price_list_rate,
      };
      // let updatedItems;
      // if (currentItems.length > name) {
      //   updatedItems = currentItems.map((item, index) =>
      //     index === name ? newItem : item
      //   );
      // } else {
      //   updatedItems = [...currentItems, newItem];
      // }

      // const updatedItems = [...currentItems, newItem];

      const totalRate = currentItems?.reduce(
        (sum, item) => sum + Number(item?.rate),
        0
      );
      // console.log(
      //   totalRate,
      //   'totalRatetotalRatetotalRatetotalRatetotalRatetotalRatetotalRatewdwqdwiq'
      // );

      const totalTaxesAndCharges = Number(
        (totalRate *
          (isNationalitySaudi
            ? 0
            : Number(vatTax?.message?.vat_tax?.tax_rate) || 0)) /
          100
      ).toFixed(2);

      const grandTotal = Number(
        totalRate +
          (totalRate *
            (isNationalitySaudi
              ? 0
              : Number(vatTax?.message?.vat_tax?.tax_rate) || 0)) /
            100
      ).toFixed(2);
      setDataSourceTax(
        isNationalitySaudi
          ? []
          : [
              {
                account_head: vatTax?.message?.vat_tax?.tax_head_account,
                rate: vatTax?.message?.vat_tax?.tax_rate,
                tax_amount: totalTaxesAndCharges,
                total: grandTotal,
                charge_type: 'On Net Total',
              },
            ]
      );
      setDataSourcePayment((prev) =>
        prev?.map((item) => ({ ...item, payment_amount: grandTotal }))
      );
      form.setFieldsValue({
        // items: updatedItems,

        taxes: isNationalitySaudi
          ? []
          : [
              {
                account_head: vatTax?.message?.vat_tax?.tax_head_account,
                rate: vatTax?.message?.vat_tax?.tax_rate,
                tax_amount: totalTaxesAndCharges,
                total: grandTotal,
                charge_type: 'On Net Total',
              },
            ],
        total_taxes_and_charges: isNationalitySaudi ? 0 : totalTaxesAndCharges,
        grand_total: grandTotal,
      });
    }
  }, [itemDetails, isNationalitySaudi, vatTax, form]);
  // const { data: itemsList, isLoading } = useQuery({
  //   queryKey: [queryKeys.getAllServicesAndItem, searchTxt],
  //   queryFn: () => getEncounterServicesAndItem(searchTxt),
  //   enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
  //   keepPreviousData: true,
  // });
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTxt],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTxt, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
  });
  console.log(itemsList, 'itemsList 222222');
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTxt(searchTxt);
    }, 300); // Adjust the delay as needed

    return () => clearTimeout(timerId);
  }, [searchTxt]);

  //  useEffect(() => {
  //    if (debouncedSearchTxt.length >= 3) {
  //      console.log('Searching for:', debouncedSearchTxt);

  //    }
  //  }, [debouncedSearchTxt]);

  useEffect(() => {
    const totalQty = dataSource.reduce(
      (total, item) => total + (Number(item.qty) || 0),
      0
    );
    const totalAmount = dataSource.reduce(
      (total, item) => total + (Number(item.amount) || 0),
      0
    );
    const netTotal = totalAmount;
    form.setFieldsValue({
      total_qty: totalQty,
      total: totalAmount,
      net_total: netTotal,
    });
  }, [dataSource]);
  console.log(type, 'typetype swww');
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          // placeholder={t.items}
          placeholder={'search by name... '}
          style={{ width: '100%', minWidth: 200 }}
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          disabled={edit}
          showSearch
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setSearchTxt(value);
          }}
          filterOption={false}
          onChange={(value) => {
            setSelectedIndex(index);
            onGetItemDetails(value?.key);
          }}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },

    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          placeholder={t.quantity}
          type="number"
          disabled={edit}
          // value={record.amount}
          value={record.qty}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount:
                e.target.value * Number(record.rate - record.discount_amount),
            };
            setDataSource(newDataSource);
          }}
          min={0}
          // style={{ width: 140 }}
        />
      ),
    },
    {
      title: t.discountAmount,
      dataIndex: 'discount_amount',
      render: (text, record, index) => (
        <Input
          disabled={edit}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              discount_amount: e.target.value,
              amount: record?.qty * (record?.rate - e.target.value),
            };
            console.log(newDataSource, 'newDataSource');
            setDataSource(newDataSource);
          }}
          placeholder={t.discountAmount}
          type="number"
          value={record.discount_amount}
          min={0}
          width={100}
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.Rate,
      dataIndex: 'rate',
      render: (text, record, index) => (
        <Input
          disabled={edit}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              rate: e.target.value,
              amount: record?.qty * (e.target.value - record.discount_amount),
            };
            console.log(newDataSource, 'newDataSource');
            setDataSource(newDataSource);
          }}
          placeholder={t.Rate}
          type="number"
          value={record.rate}
          min={0}
          width={100}
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          value={record.amount}
          min={0}
          width={100}
          disabled
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      // width: 100,
      // align: 'center',
      render: (text, record, index) => (
        <Flex gap={10}>
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => {
              setSelectedIndex(index);
              handleDetails(record.key);
            }}
          />
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Flex>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };
  const handleDetails = (key) => {
    const row = dataSource.find((item) => item.key === key);
    if (row) {
      setSelectData({
        ...row,
        schedule_date: dayjs(row.schedule_date).format('YYYY-MM-DD'),
      });
      setDataSource(
        dataSource.map((item) => ({
          ...item,
          schedule_date: dayjs(item.schedule_date).format('YYYY-MM-DD'),
        }))
      );
      setOpen(true);
      console.log('Row details:', row);
    }
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <ModalAppItemDetailsSalesInvoice
        setDataSource={setDataSource}
        dataSource={dataSource}
        selectedIndex={selectedIndex}
        open={open}
        setOpen={setOpen}
        t={t}
        selectData={selectData}
      />
    </Card>
  );
};

export default ItemListSalesInvoice;
